// src/pages/CourseTime/components/slides/slideRegistry.js
import ContentPointsListSlide from './layouts/ContentPointsListSlide.comp';
import ContentPointsWithImageSlide from './layouts/ContentPointsWithImageSlide.comp';
import ContentSinglePointWithImageSlide from './layouts/ContentSinglePointWithImageSlide.comp';
import ContentDescriptionSlide from './layouts/ContentDescriptionSlide.comp';
import AssessmentIntroSlide from './layouts/AssessmentIntroSlide.comp';
import SectionIntroSlide from './layouts/SectionIntroSlide.comp';
import GraphicAndTextSlide from './layouts/GraphicAndTextSlide.comp';
import SessionStartSlide from './layouts/SessionStartSlide.comp';
import StepBlockSlide from './layouts/StepBlockSlide.comp';
import LongTextSlide from './layouts/LongTextSlide.comp';
import SubtitleSlide from './layouts/SubtitleSlide.comp';
import ListSlide from './layouts/ListSlide.comp';
import RecapSlide from './layouts/RecapSlide.comp';
import ReentryMapSlide from './layouts/ReentryMapSlide.comp';
import WorkedExampleSlide from './layouts/WorkedExampleSlide.comp';
import DecisionPointSlide from './layouts/DecisionPointSlide.comp';
import AnalysisFrameworkSlide from './layouts/AnalysisFrameworkSlide.comp';
import PledgeSlide from './layouts/PledgeSlide.comp';
import VideoSlide from './layouts/VideoSlide.comp';
import AssessmentResultSlide from './layouts/AssessmentResultSlide.comp';
import HtmlContentSlide from './layouts/HtmlContent/HtmlContentSlide.comp';

// slide.SlideLayout -> layout component. The five activity layouts
// (JOURNALING_SELF_REFLECTION_ACTIVITY, SHARE_WORK_FILE_ACTIVITY,
// POLL_QUIZ_ACTIVITY, DISCUSSION_ACTIVITY, ASSESSMENT_ACTIVITY) are handled
// inline by SlideRenderer and deliberately absent here.
export const slideRegistry = {
  Introduction_title_with_goals: ContentPointsListSlide,
  content_3_points_with_no_image: ContentPointsListSlide,
  content_4_points_with_no_image: ContentPointsListSlide,

  content_2_points_with_1_image: ContentPointsWithImageSlide,
  content_3_points_with_1_image: ContentPointsWithImageSlide,

  content_single_point_with_1_image: ContentSinglePointWithImageSlide,

  content_description_with_no_image: ContentDescriptionSlide,
  final_summary: ContentDescriptionSlide,

  PRE_ASSESSMENT_INTRO: AssessmentIntroSlide,
  POST_ASSESSMENT_INTRO: AssessmentIntroSlide,

  SECTION_INTRO: SectionIntroSlide,

  TemplateGraphicAndText: GraphicAndTextSlide,
  TemplateSessionStart: SessionStartSlide,
  TemplateStepBlock: StepBlockSlide,
  TemplateLongText: LongTextSlide,
  TEMPLATE_WITH_SUBTITLE: SubtitleSlide,
  TemplateList: ListSlide,
  TemplateRecap: RecapSlide,
  TemplateReentryMap: ReentryMapSlide,
  TemplateWorkedExample: WorkedExampleSlide,
  TemplateDecisionPoint: DecisionPointSlide,
  TemplateAnalysisFramework: AnalysisFrameworkSlide,
  PledgeTemplate: PledgeSlide,
  VideoTemplate: VideoSlide,
  TemplateHtmlContent: HtmlContentSlide,
  ASSESSMENT_RESULT: AssessmentResultSlide,
};

export default slideRegistry;
